import { mediaQueries } from '../env';
import { emitDialogCloseEvent, lockPageScroll, unlockPageScroll } from '../util';

// DOM
const navDialog = document.querySelector(".js-jg-nav-m");
const openNavButton = document.querySelector(".js-jg-nav-m-open");
const closeNavButton = document.querySelector(".js-jg-nav-m-close");

// Watchers
// Mobile menu breakpoint
const mediaQuery = window.matchMedia(mediaQueries.mediumUp);

// State
let hasDom = false;

function openNav() {
    navDialog.showModal();
    lockPageScroll();
}

function closeNav() {
    navDialog.close();
    unlockPageScroll();
}

function handleMenuClick(event) {
    const linkElement = event.target.closest('a');
    if (linkElement && navDialog.contains(linkElement)) {        
        closeNav();
    }    
}

function handleMediaQueryChange(event) {
    if (event.matches) {
        closeNav();
        downgrade();
    } else {
        upgrade();
    }
}

function watchMedia() {
    mediaQuery.addEventListener('change', handleMediaQueryChange);
}

function upgrade() {
    openNavButton.addEventListener('click', openNav);
    closeNavButton.addEventListener('click', closeNav);
    navDialog.addEventListener('click', handleMenuClick);
    navDialog.addEventListener('close', emitDialogCloseEvent);   
}

function downgrade() {
    openNavButton.removeEventListener('click', openNav);
    closeNavButton.removeEventListener('click', closeNav);   
    navDialog.removeEventListener('click', handleMenuClick); 
    navDialog.removeEventListener('close', emitDialogCloseEvent);   
}

function init() {
    hasDom = navDialog && openNavButton && closeNavButton;
    if ( ! hasDom) return;

    watchMedia();
    // Check initial breakpoint
    handleMediaQueryChange(mediaQuery);
}

export default {
    init
}
